export type VibError = {
  type: string;
  status: number;
  title: string;
  detail: string;
  instance: string;
  timestamp: string;
  additionalData?: any;
};

export enum VibErrorMessages {
  NOT_AUTHENTICATED = 'Usuário não autenticado. Por favor, faça login.',
  BLOCKED_PLATFORM_USER = 'Você atingiu o limite de tentativas de login. Contate o time de suporte para regularizar sua conta ou tente novamente mais tarde.',
  WRONG_CREDENTIALS = 'Credenciais incorretas.',
  BOT_CONFIG_PAYMENT_METHOD_AT_LEAST_ONE = 'Para manter ativas as vendas da Comunidade, é necessário ter pelo menos uma forma de pagamento habilitada',
  INCONSISTENT_PAYOUT = 'O payout apresenta inconsistências no valor.',
}
